export function groupPathToLabel(groupPath: string): string {
  return groupPath.replace(/^\//, '')
}
